import { render, staticRenderFns } from "./SmileCubeStairs.vue?vue&type=template&id=71f002f2&scoped=true&"
import script from "./SmileCubeStairs.vue?vue&type=script&lang=js&"
export * from "./SmileCubeStairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f002f2",
  null
  
)

export default component.exports